import popup, { initState as popupState } from './popup.reducer';
import { StoreState } from '@Types';
import { combineReducers } from 'redux';
import { moduleNamespace } from '@Store/config.store';

export const initialState: StoreState = {
	popup: popupState,
};

export default combineReducers({
	popup,
});

export const reducerKey = moduleNamespace;

export const reducerWhiteList = [`${moduleNamespace}.map`];
